import Paper from '@mui/material/Paper';
import '..//App.css';
import { Container, Grid } from '@mui/material';
import { Box } from '@mui/system';
import TopBanner from './TopBanner';
import Pools from './Pools';

export default function Home() {
  return (
    <Box>
      <TopBanner />
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>

        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={9}>
            <Grid container spacing={3} id="coupons">

              {/* Top banner*/}
              <Grid item xs={12} id="faq">

                <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

                  <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ margin: "40px" }}>
                    <iframe                      
                      title="expekt"
                      src="https://ntrfr.expekt.se/ad.aspx?bid=22339&pid=3746939"
                      width="600"
                      height="400"
                      marginWidth={0}
                      marginHeight={0}
                      frameBorder={0}
                      scrolling="no"
                      style={{ border: 0 }}
                    ></iframe>
                  </Grid>

                </Paper>
              </Grid>

           

              {/* Faq */}
              <Grid item xs={12} id="faq">
                <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                  <Pools />
                </Paper>
              </Grid>

            </Grid>
          </Grid>

          
        </Grid>
      </Container>
    </Box>
  );

}


